import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { listRakApi, addRakApi, updateRacksProductApi } from "../../auth/authService";

export const fetchMasterRaking = createAsyncThunk(
    "masterRaking/fetchMasterRaking",
    async (params = {}, thunkAPI) => {
        try {
            const token = thunkAPI.getState().auth.token;

            const {
                page = 1,
                per_page = 10,
                search = ""
            } = params;

            const res = await listRakApi(token, {
                page,
                per_page,
                search
            });

            return res;
        } catch (err) {
            console.log("ERROR:", err);
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Gagal mengambil data"
            );
        }
    }
);


export const createMasterRaking = createAsyncThunk(
    "masterRaking/create",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await addRakApi(payload);
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response.data);
        }
    }
);

export const updateMasterRaking = createAsyncThunk(
    "masterRaking/update",
    async ({ id, ...payload }, { rejectWithValue }) => {
        try {
            const res = await updateRacksProductApi(id, payload);
            return res.data; // sesuaikan dengan response API kamu
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const masterRakingSlice = createSlice({
    name: "masterRaking",
    initialState: {
        data: [],
        pagination: {},
        loading: false,
        error: null,
    },
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(fetchMasterRaking.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchMasterRaking.fulfilled, (state, action) => {
                //console.log("FULLFILLED PAYLOAD:", action.payload);
                state.loading = false;
                state.data = action.payload.data;
                state.pagination = action.payload.pagination; 
                //console.log("PAYLOAD:", action.payload);
            })
            .addCase(fetchMasterRaking.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                //console.log("REJECTED:", action.payload);
            })
            .addCase(createMasterRaking.fulfilled, (state, action) => {
                if (action.payload?.data) {
                    state.data.unshift(action.payload.data);
                }
            })
            .addCase(updateMasterRaking.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateMasterRaking.fulfilled, (state, action) => {
                state.loading = false;

                const updated = action.payload?.data;

                if (updated) {
                    state.data = state.data.map((item) =>
                        item.id === updated.id ? updated : item
                    );
                }
            })
            .addCase(updateMasterRaking.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default masterRakingSlice.reducer;